export const PERMISSION_KEYS_HEADER = 'X-WSPHERE-PERMISSION-KEYS';

/** Config key under which tenant feature flags are stored. Must match the key used by the feature-flags service. */
export const FEATURE_FLAGS_CONFIG_KEY = 'feature_flags';

/** When enabled for a tenant, roles become DB-authoritative and editable; resolution ignores the code registry. */
export const CUSTOM_ROLES_FEATURE_FLAG = 'CUSTOM_ROLES';
